import { decodeMessageContent } from '../internal/conversation/decodeMessageContent';

import type { ConversationMessage } from './pickFinalReply';

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null;

export type AgentProgress = { kind: 'tool'; name: string } | { kind: 'narration'; text: string };

function isStructuredAnswer(text: string): boolean {
  const trimmed = text.trimStart();
  return trimmed.startsWith('{') || trimmed.startsWith('```');
}

export function readProgress(messages: ConversationMessage[]): AgentProgress | undefined {
  let latestTool: AgentProgress | undefined;
  let latestNarration: AgentProgress | undefined;

  for (const message of messages) {
    if (message.role !== 'assistant') {
      continue;
    }
    const decoded = decodeMessageContent(message.content);
    if (!decoded || !Array.isArray(decoded.content)) {
      continue;
    }
    for (const block of decoded.content) {
      if (!isRecord(block)) {
        continue;
      }
      if (block.type === 'tool_use' && typeof block.name === 'string') {
        latestTool = { kind: 'tool', name: block.name };
      }
      if (
        block.type === 'text' &&
        typeof block.text === 'string' &&
        block.text.trim() &&
        !isStructuredAnswer(block.text)
      ) {
        latestNarration = { kind: 'narration', text: block.text };
      }
    }
  }

  return latestTool ?? latestNarration;
}
